// Stubs for GraphQL types that were removed during the Solana-backend schema migration.
// Companion to the api/* stubs from commit 35919742. These keep UI imports compiling;
// runtime features that depend on these types are non-functional until the backend exposes
// equivalents. Delete this file when each consumer is migrated to the new schema.

export enum GameState {
  Open = 'Open',
  Inprogress = 'Inprogress',
  Pending = 'Pending',
  Close = 'Close',
  Draft = 'Draft'
}

export enum BalanceOperationType {
  UserWon = 'UserWon',
  UserLose = 'UserLose',
  UserAddBet = 'UserAddBet',
  UserRejectedBet = 'UserRejectedBet',
  GameResolve = 'GameResolve',
  Hold = 'Hold',
  HourlyFee = 'HourlyFee',
  NetworkFee = 'NetworkFee',
  NotDefined = 'NotDefined',
  Unhold = 'Unhold',
  UserDeposit = 'UserDeposit',
  UserWithdraw = 'UserWithdraw',
  Bonus = 'Bonus',
  BonusRemoved = 'BonusRemoved'
}

export enum GameSetupResult {
  Rejected = 'Rejected',
  TakeProfit = 'TakeProfit',
  StopLoss = 'StopLoss'
}

export enum BetType {
  Price = 'Price',
  Updown = 'Updown'
}

export interface Bet {
  type?: BetType
  isUp?: boolean
  price?: number | string
  game?: { assetId?: string } & Record<string, unknown>
  [key: string]: unknown
}
